// extracted by mini-css-extract-plugin
module.exports =  {"collect-trigger":"TyvYg_h","collectTrigger":"TyvYg_h"};